import * as ng from 'angular';
import * as _ from 'underscore';
import * as uib from 'angular-ui-bootstrap';

import { defaults, overrides, FormEditorController } from './form-editor.component';

export class FormAddStandardController {
   fields:Field[] = [];

   static $inject = [
      '$uibModalInstance', 'formEditor', 'options'
   ];

   constructor(
      private $uibModalInstance:uib.IModalInstanceService,
      private formEditor:FormEditorController,
      options:{disabled?:string[]}
   ) {
      let add = f => this.$uibModalInstance.close(f);

      const standardFields = _.map(defaults.standard, f => ng.extend({}, f, overrides.standard[f.key]))
      for (const f of standardFields) {
         let field = new Field(f, add);

         if (formEditor.hasField(f.key)
            || options.disabled.indexOf(f.key) > -1) {
            field.disabled = true;
         }

         this.fields.push(field);
      }

      for (const f of [defaults.textLabel, defaults.divider, defaults.eventDetails]) {
         let field = new Field(f, add);

         if (options.disabled.indexOf(f.type) > -1) {
            field.disabled = true;
         }

         this.fields.push(field);
      }

      this.fields.sort((a, b) => {
         var textA = a.title.toUpperCase();
         var textB = b.title.toUpperCase();
         return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
   }

   addSurvey(type) {
      this.$uibModalInstance.dismiss('cancel');
      this.formEditor.addSurvey(type);
   }

   cancel() {
      this.$uibModalInstance.dismiss('cancel');
   }
}

class Field {
   disabled = false;
   title:string;

   get type():string {
      return this.field.type;
   }

   constructor(private field:any, private _add:Function) {
      if (_.contains(['textLabel', 'divider', 'eventDetails'], field.type)) {
         this.title = defaults.strings.titles[field.type];
      } else {
         this.title = defaults.strings.titles[field.key];
      }
   }

   add() {
      if (!this.disabled) {
         this._add(this.field);
      }
   }
}

ng.module('e360')
   .controller('FormAddStandardController', FormAddStandardController);
